import { render, staticRenderFns } from "./confirm-order.vue?vue&type=template&id=76d47d8e"
import script from "./confirm-order.vue?vue&type=script&lang=js"
export * from "./confirm-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports